import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Sidebar from "../components/Sidebar";

const Analytics = () => {
    const university_id = localStorage.getItem("universityId");

    const [report, setReport] = useState([]);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    useEffect(() => {
        fetch(`${apiUrl}/reports/${university_id}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch reports");
                }
                return response.json();
            })
            .then((data) => setReport(data))
            .catch((error) => {
                console.error("Error fetching reports:", error);
               // setError("Failed to load reports. Please try again.");
            });
    }, []);

    if (error) {
        return <p className="text-danger">{error}</p>;
    }


    return (
        <div className="dashboard">
            <Sidebar/>
            <main className="main-content">
                <header className="header component">
                    <span className="component-header">Analytics</span>
                </header>
                <p><a href="/dashboard"> Home </a> &gt; Analytics </p>
                <hr/>
                <div className="relative w-full  h-100vh pt-0 overflow-hidden">
                    <iframe
                        src={report}
                        title="Looker Studio Dashboard" className="absolute top-0 left-0 w-full h-full border-0"
                        frameBorder="0" allowFullScreen=""
                        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
                </div>
            </main>
        </div>
    );
};

export default Analytics;